import React from 'react';
import { ErrorBoundary, PaymentErrorFallback } from '@/components/ui/ErrorBoundary';

// Payment callback page imports - COPIED EXACTLY from App.tsx
const PaymentSuccess = React.lazy(() => import('@/pages/PaymentSuccess'));
const PaymentFailure = React.lazy(() => import('@/pages/PaymentFailure'));
const PaypalSuccess = React.lazy(() => import('@/pages/PaypalSuccess'));
const PaypalFailure = React.lazy(() => import('@/pages/PaypalFailure'));
const FonepayCallback = React.lazy(() => import('@/pages/api/fonepay-callback'));
const EsewaSuccess = React.lazy(() => import('@/pages/payment-callback/esewa-success'));
const EsewaFailure = React.lazy(() => import('@/pages/payment-callback/esewa-failure'));

// Payment callback routes (public access) - All payment gateway redirects
export const paymentRoutes = [
  {
    path: 'payment-success', // PayU success redirect (public access)
    element: (
      <ErrorBoundary fallback={PaymentErrorFallback}>
        <PaymentSuccess />
      </ErrorBoundary>
    ),
  },
  {
    path: 'payment-failure', // PayU failure redirect (public access)
    element: (
      <ErrorBoundary fallback={PaymentErrorFallback}>
        <PaymentFailure />
      </ErrorBoundary>
    ),
  },
  {
    path: 'paypal-success', // PayPal success redirect (public access)
    element: (
      <ErrorBoundary fallback={PaymentErrorFallback}>
        <PaypalSuccess />
      </ErrorBoundary>
    ),
  },
  {
    path: 'paypal-failure', // PayPal failure redirect (public access)
    element: (
      <ErrorBoundary fallback={PaymentErrorFallback}>
        <PaypalFailure />
      </ErrorBoundary>
    ),
  },
  {
    path: 'payment-callback/fonepay', // Fonepay payment callback (public access)
    element: (
      <ErrorBoundary fallback={PaymentErrorFallback}>
        <FonepayCallback />
      </ErrorBoundary>
    ),
  },
  {
    path: 'payment-callback/esewa-success', // eSewa success callback (public access)
    element: (
      <ErrorBoundary fallback={PaymentErrorFallback}>
        <EsewaSuccess />
      </ErrorBoundary>
    ),
  },
  {
    path: 'payment-callback/esewa-failure', // eSewa failure callback (public access)
    element: (
      <ErrorBoundary fallback={PaymentErrorFallback}>
        <EsewaFailure />
      </ErrorBoundary>
    ),
  },
];